import type { BaseMarkupComponent } from '~/models/BaseMarkupComponent.model';
import FetchFactory from '../factory';

const CONTROLLER_PATH = '/api-electra/Manufacturer';

export type MarkupData = {
  PageContent: BaseMarkupComponent[];
  MetaTitle?: string;
  MetaDescription?: string;
  MetaKeywords?: string;
};

class ManufacturerModule extends FetchFactory<any> {
  async getManufacturerPage(slug: string): Promise<MarkupData> {
    const url = `${CONTROLLER_PATH}/GetManufacturerPage`;

    const data = await this.get(url, {
      params: {
        manufacturerSlug: slug,
      },
    });

    return data || {};
  }
}

export default ManufacturerModule;
